__webpack_require__.p = "https://tlkfrontprod.azureedge.net/template-builder-production/launcher.editor/";